<template>
  <svg ref="svgImg" :viewBox="`0 0 ${state.aspectWidth} 100`" :font-family="fontFamily" role="presentation">
    <foreignObject :width="state.aspectWidth" height="100">
      <div class="xml-div-container">
        <div class="text-container" :style="`color: ${svgColor}; white-space: nowrap;`">
          <div
            v-for="(row, i) in formatted"
            :key="`etch-${i}`"
            class="xml-div-text"
            :style="`font-size: ${state.fontSize}px; line-height: ${lineHeight}em;`"
          >
            {{ row }}
          </div>
        </div>
      </div>
    </foreignObject>
  </svg>
</template>

<script setup lang="ts">
import { CustomTextSvg } from '~/util/svgjs';

const svgImg = ref<SVGGraphicsElement | null>(null);

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  lineHeight: {
    type: Number,
    default: 1.1,
  },
  baseFontSize: {
    type: Number,
    default: 16,
  },
  baseWidth: {
    type: Number,
    default: 100,
  },
  baseHeight: {
    type: Number,
    default: 100,
  },
  svgColor: {
    type: String,
    default: '#655F5D',
  },
  fontFamily: {
    type: String,
    default: 'neue-haas-grotesk-display',
  },
  aspectRatio: {
    type: Object as () => { width: number; height: number },
    default() {
      return { width: 100, height: 100 };
    },
  },
});

const state = reactive({
  svg: undefined as CustomTextSvg | undefined,
  svgRect: undefined as DOMRect | undefined,
  fontSize: props.baseFontSize,
  aspectWidth: 100,
});

const formatted = computed<string[]>(() => props.text.split('\n'));
// const lines = computed<number>(() => formatted.value.length);
// const aspectHeight = computed<number>(() => {
//   return Math.round(
//     (state.aspectWidth * props.aspectRatio.height) / props.aspectRatio.width,
//   );
// });
watch(
  () => props.text,
  () => {
    state.svgRect = svgImg.value?.getBBox();
    state.fontSize = props.baseFontSize;
    nextTick(() => {
      const newer = svgImg.value?.getBBox();
      const textContainer = svgImg.value?.querySelector('.text-container') as HTMLElement;
      const newWidth = textContainer ? textContainer.scrollWidth : newer ? newer.width : props.baseWidth;
      const newHeight = textContainer ? textContainer.scrollHeight : newer ? newer.height : props.baseHeight;
      let widthFont = state.fontSize;
      let heightFont = state.fontSize;
      let fontChanger = state.fontSize;
      if (newWidth > props.baseWidth) {
        widthFont = state.svg?.svgWidthFont(newWidth) || state.fontSize;
      }
      if (newHeight > props.baseHeight) {
        heightFont = state.svg?.svgHeightFont(newHeight) || state.fontSize;
      }
      fontChanger = widthFont;
      if (heightFont < fontChanger) {
        fontChanger = heightFont;
      }
      if (fontChanger !== state.fontSize) {
        state.fontSize = fontChanger;
        state.svg?.updateFontsize(state.fontSize);
      }
    });
  }
);

onMounted(() => {
  state.svg = new CustomTextSvg({
    text: props.text,
    baseFontSize: props.baseFontSize,
    baseWidth: props.baseWidth,
    baseHeight: props.baseWidth,
    fontFamily: props.fontFamily,
  });
});
</script>

<style lang="scss" scoped>
.xml-div-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.xml-div-text {
  display: flex;
  justify-content: center;
  font-weight: 600;
}
</style>
